export default __webpack_public_path__ + "static/media/shinysilver-Logo.93fbae8c.png";